module.exports = __webpack_public_path__ + "assets/img/index-banner3-1.636243df.jpg";